import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import Header from "./components/header";
import Main from "./components/main";
import Footer from "./components/footer";
import ChatMeSDK from "./components/ChatMeScript";
import ScrollToTopButton from "../../components/ScrollToTopButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

const PrivacyPolicy = () => {
  return (
    <div className="flex flex-col w-full min-h-screen">
      <Header />
      <div className="bg-[#031602] flex-1 pt-20">
        <div className="container mx-auto px-4 py-8 text-white">
          <div className="rounded-lg">
            <h1 className="text-4xl font-medium pb-10 text-center bg-gradient-to-b from-white to-[#50B553] bg-clip-text text-transparent relative">
              Chính sách bảo mật
            </h1>
          </div>
          {/* main content */}
          <div className="text-base font-light flex flex-col gap-5">
            <div className="content-header">
              <p>
                Chào mừng bạn đến với Chatme.vn – nền tảng trợ lý AI hỗ trợ chăm
                sóc khách hàng và tổng đài thông minh. Chúng tôi cam kết bảo vệ
                quyền riêng tư và bảo mật thông tin cá nhân của bạn. Chính sách
                này giải thích cách chúng tôi thu thập, sử dụng, lưu trữ, chia
                sẻ và bảo vệ dữ liệu cá nhân khi bạn sử dụng dịch vụ của
                Chatme.vn.
              </p>
              Bằng việc truy cập và sử dụng Chatme.vn, bạn được xem là đã đồng ý
              với các điều khoản trong Chính sách bảo mật này.
            </div>
            {/* section 1 */}
            <div>
              <h5 className="font-medium">1. Giới thiệu</h5>
              <p>1.1. Mục đích thu thập thông tin cá nhân:</p>
              <p>Chúng tôi thu thập thông tin người dùng để:</p>
              <ul className="list-disc list-inside ml-4">
                <li>
                  Hỗ trợ khách hàng trong quá trình đăng ký, thanh toán và sử
                  dụng dịch vụ.
                </li>
                <li>
                  Cung cấp thông tin sản phẩm, chương trình ưu đãi và hỗ trợ
                  theo yêu cầu.
                </li>
                <li>
                  Cải thiện trải nghiệm người dùng và cá nhân hóa dịch vụ.
                </li>
                <li>
                  Gửi thông báo, bản tin hoặc thông tin kỹ thuật về nền tảng.
                </li>
                <li>
                  Giải quyết khiếu nại, phản hồi hoặc các vấn đề phát sinh liên
                  quan đến giao dịch.
                </li>
              </ul>
              <p>1.2. Phạm vi thu thập thông tin</p>
              <p>
                Chính sách áp dụng cho tất cả người dùng Chatme.vn, bao gồm
                khách hàng đăng ký dịch vụ và khách truy cập website.
              </p>
              <ul className="list-disc list-inside ml-4">
                <li>
                  Thông tin cá nhân: Họ tên, email, số điện thoại, địa chỉ,
                  thông tin thanh toán, thông tin đăng nhập.
                </li>
                <li>
                  Thông tin phi cá nhân: Loại trình duyệt, thiết bị truy cập,
                  địa chỉ IP, dữ liệu hành vi người dùng.
                </li>
                <li>
                  Cookie & Công nghệ theo dõi: Được sử dụng để cải thiện hiệu
                  suất, cá nhân hóa nội dung và phục vụ mục đích tiếp thị. Người
                  dùng có thể tùy chỉnh hoặc từ chối cookie qua cài đặt trình
                  duyệt.
                </li>
                <li>
                  Thông tin từ bên thứ ba: Trong một số trường hợp, Chatme.vn có
                  thể tích hợp dữ liệu từ dịch vụ của đối tác (ví dụ: hệ thống
                  thanh toán, mạng xã hội) để nâng cao trải nghiệm.
                </li>
              </ul>
              <p>1.3. Sự đồng ý và chấp thuận</p>
              <p>
                Khi sử dụng dịch vụ của Chatme.vn, bạn đồng ý để chúng tôi thu
                thập, xử lý và sử dụng dữ liệu của bạn theo nội dung được mô tả
                trong chính sách này.
              </p>
            </div>
            {/* section 2 */}
            <div>
              <h5 className="font-medium">2. Thời gian lưu trữ thông tin</h5>
              <ul className="list-disc list-inside ml-4">
                <li>
                  Thông tin cá nhân của người dùng sẽ được lưu trữ cho đến khi
                  người dùng yêu cầu xóa bỏ, hoặc tự xóa tài khoản.
                </li>
                <li>
                  Trong trường hợp không có yêu cầu, thông tin vẫn sẽ được lưu
                  trữ trên hệ thống của Chatme.vn để phục vụ cho việc cung cấp
                  dịch vụ và tuân thủ quy định pháp luật.
                </li>
              </ul>
            </div>
            {/* section 3 */}
            <div>
              <h5 className="font-medium">
                3. Những người hoặc tổ chức có thể tiếp cận thông tin
              </h5>
              <p>3.1. Sử dụng nội bộ</p>
              <p>
                Thông tin của bạn có thể được chia sẻ nội bộ giữa các bộ phận
                của Chatme.vn để vận hành, bảo trì và cải thiện dịch vụ.
              </p>
              <p>3.2. Tự động hóa & cải thiện dịch vụ</p>
              <p>
                Chatme.vn có thể sử dụng công nghệ AI để phân tích dữ liệu và tự
                động hóa quy trình chăm sóc khách hàng nhằm nâng cao trải
                nghiệm.
              </p>
              <p>3.3. Cá nhân hóa trải nghiệm</p>
              <p>
                Dữ liệu được dùng để cá nhân hóa nội dung, đề xuất dịch vụ phù
                hợp và gửi thông báo theo sở thích người dùng.
              </p>
              <p>3.4. Chia sẻ với bên thứ ba</p>
              <p>
                Thông tin có thể được chia sẻ với các đối tác cung cấp dịch vụ
                như thanh toán, lưu trữ dữ liệu, gửi email,… với cam kết bảo mật
                nghiêm ngặt.
              </p>
              <p>3.5. Yêu cầu pháp lý</p>
              <p>
                Chúng tôi có thể tiết lộ thông tin nếu được yêu cầu bởi cơ quan
                nhà nước có thẩm quyền theo quy định pháp luật.
              </p>
              <p>3.6. Dữ liệu tổng hợp hoặc ẩn danh</p>
              <p>
                Chatme.vn có thể sử dụng dữ liệu đã được ẩn danh hoặc tổng hợp
                để phân tích, nghiên cứu hoặc thống kê.
              </p>
              <p>3.7. Quyền và lựa chọn của người dùng</p>
              <ul className="list-disc list-inside ml-4">
                <li>
                  Truy cập & chỉnh sửa: Bạn có thể đăng nhập để xem, chỉnh sửa
                  hoặc cập nhật thông tin cá nhân bất kỳ lúc nào.
                </li>
                <li>
                  Tùy chọn nhận thông báo: Người dùng có thể quản lý việc nhận
                  email, tin nhắn hoặc thông báo trong phần cài đặt tài khoản.
                </li>
                <li>
                  Quản lý cookie: Có thể điều chỉnh tùy chọn cookie trong trình
                  duyệt.
                </li>
              </ul>
            </div>
            {/* section 4 */}
            <div>
              <h5 className="font-medium">4. Bảo mật dữ liệu</h5>
              <p>4.1. Biện pháp bảo mật</p>
              <p>
                Chatme.vn áp dụng các biện pháp bảo mật kỹ thuật và quản trị
                theo tiêu chuẩn quốc tế để ngăn chặn truy cập trái phép, mất mát
                hoặc lạm dụng dữ liệu.
              </p>
              <p>4.2. Phản hồi sự cố dữ liệu</p>
              <p>
                Trong trường hợp xảy ra vi phạm dữ liệu, Chatme.vn sẽ thông báo
                ngay cho người dùng bị ảnh hưởng và phối hợp với cơ quan có thẩm
                quyền để xử lý theo luật định.
              </p>
            </div>
            {/* section 5 */}
            <div>
              <h5 className="font-medium">
                5. Liên kết và dịch vụ của bên thứ ba
              </h5>
              <ul className="list-disc list-inside ml-4">
                <li>
                  Website của chúng tôi có thể chứa liên kết đến các trang web
                  bên thứ ba. Chatme.vn không chịu trách nhiệm về nội dung hoặc
                  chính sách bảo mật của các trang web đó
                </li>
                <li>
                  Khi sử dụng dịch vụ bên thứ ba tích hợp, việc xử lý dữ liệu
                  của bạn sẽ tuân theo chính sách của đối tác liên quan.
                </li>
              </ul>
            </div>
            {/* section 6 */}
            <div>
              <h5 className="font-medium">6. Quyền riêng tư của trẻ em</h5>
              <ul className="list-disc list-inside ml-4">
                <li>
                  Chatme.vn không cung cấp dịch vụ cho trẻ em dưới 13 tuổi và
                  không cố ý thu thập thông tin từ đối tượng này.
                </li>
                <li>
                  Nếu phát hiện việc thu thập thông tin từ trẻ em mà không có sự
                  đồng ý của cha mẹ/người giám hộ, chúng tôi sẽ tiến hành xóa
                  ngay lập tức theo yêu cầu
                </li>
              </ul>
            </div>
            {/* section 7 */}
            <div>
              <h5 className="font-medium">
                7. Địa chỉ của đơn vị thu thập và quản lý thông tin
              </h5>
              <p>Công ty Cổ phần Giải pháp và Công nghệ Giáo dục Cyber Uni</p>
              <ul className="list-disc list-inside ml-4">
                <li className="flex items-center gap-2">
                  <img
                    src="/media/images/icon/location.png"
                    alt="location icon"
                    className="size-4"
                  />
                  <p>Địa chỉ: 519 Kim Mã, Quận Ba Đình, Hà Nội</p>
                </li>
                <li className="flex items-center gap-2">
                  <img
                    src="/media/images/icon/telephone.png"
                    alt="telephone icon"
                    className="size-4"
                  />
                  <p>Hotline: 0862595658</p>
                </li>
                <li className="flex items-center gap-2">
                  <img
                    src="/media/images/icon/email.png"
                    alt="email icon"
                    className="size-4"
                  />
                  <p>Email: support@cyberuni.vn</p>
                </li>
                <li className="flex items-center gap-2">
                  <img
                    src="/media/images/icon/globe.png"
                    alt="website icon"
                    className="size-4"
                  />
                  <p>
                    Website:{" "}
                    <a href="https://chatme.vn" className="text-blue-500">
                      https://chatme.vn
                    </a>
                  </p>
                </li>
              </ul>
            </div>
            {/* section 8 */}
            <div>
              <h5 className="font-medium">
                8. Phương thức và công cụ để người dùng tiếp cận & chỉnh sửa dữ
                liệu Khách hàng có thể:
              </h5>
              <ul className="list-disc list-inside ml-4">
                <li>
                  hương thức và công cụ để người dùng tiếp cận & chỉnh sửa dữ
                  liệu Khách hàng có thể: Truy cập vào tài khoản trên Chatme.vn
                  để chỉnh sửa hoặc xóa thông tin cá nhân.
                </li>
                <li>
                  Liên hệ với bộ phận hỗ trợ qua email hoặc hotline để yêu cầu
                  điều chỉnh thông tin.
                </li>
                <li>
                  Gửi yêu cầu chính thức về việc xóa hoặc ngừng xử lý dữ liệu cá
                  nhân nếu không còn sử dụng dịch vụ.
                </li>
              </ul>
            </div>
            {/* section 9 */}
            <div>
              <h5 className="font-medium">
                9. Cập nhật và thay đổi chính sách
              </h5>
              <p>
                Chatme.vn có thể cập nhật chính sách bảo mật này theo thời gian
                để phù hợp với quy định pháp luật và nhu cầu dịch vụ.
              </p>
              <p>
                Mọi thay đổi sẽ được công bố công khai trên website và có hiệu
                lực kể từ ngày đăng tải.
              </p>
              <div className="flex items-center gap-2">
                <img
                  src="/media/images/icon/pushpin.png"
                  alt="pushpin icon"
                  className="size-4"
                />
                <p>
                  Khi tiếp tục sử dụng dịch vụ của Chatme.vn, bạn xác nhận rằng
                  đã đọc, hiểu và đồng ý với toàn bộ nội dung của Chính sách bảo
                  mật này.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
